import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import { getOfferSourceSelectOptions } from '../../../app/sponsoredAds/services/servicesSponsoredAds';
import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';

export default withSelectFormik(withInputErrorMessage(remoteOptionSelectFactory({
   getSuggestionsPromise: getOfferSourceSelectOptions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndIdAsValueAndNameAsLabel,
})));
